import { getEntityReferenceTitle } from "@/utils/entity-reference.utils.ts";
import { useTranslation } from "react-i18next";
import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemEntityReference({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const { t } = useTranslation();
  return (
    <ListItem
      preTitle={label ?? field.title}
      title={
        fieldValue?.value_references
          ?.map((reference) =>
            getEntityReferenceTitle(reference, t("custom_fields:reference_archived"))
          )
          .join(", ") || "-"
      }
    />
  );
}
